<template>
	<div>
	  <div class="form-group row">
		<label class="col-sm-2 col-form-label">Folio:</label>
		<div class="col-sm-2">
		  <input
			type="nombre"
			v-model="venta.folio"
			:disabled="permiso == 2"
			class="form-control"
			placeholder="Folio de la venta"
		  />
		</div>
		<label class="col-sm-1 col-form-label">Fecha:</label>
		<i class="fa fa-calendar"></i>
		<datetime
		  :disabled="true"
		  type="date"
		  :phrases="{ ok: 'Ok', cancel: 'Cancelar' }"
		  zone="America/Cancun"
	  value-zone="America/Cancun"
		  v-model="venta.fecha"
		></datetime>
	  </div>
	  <div class="form-group row">
		<label class="col-sm-2 col-form-label">Cliente:</label>
		<div class="col-sm-6">
		  <cool-select
			v-model="venta.cliente"
			:items="lista_clientes"
			item-text="nombre_cliente"
			@select="getidCliente(venta.cliente)"
		  ></cool-select>
		</div>
	  </div>
  
	  <!--  <div class="form-group row">
		<label class="col-sm-2 col-form-label">Cliente:</label>
		<div class="col-sm-6">
		  <select class="form-control" v-model="venta.idcliente" @change="getidCliente">
			<option
			  v-for="obj in lista_clientes"
			  :value="obj.idcliente"
			  :key="obj.idcliente"
			>{{obj.nombre+" "+obj.apellido}}</option>
		  </select>
		</div>
	  </div>-->
	  <div class="form-group row">
		<label class="col-sm-2 col-form-label">Código:</label>
		<div class="col-sm-3">
		  <input
			v-model="codigo"
			type="nombre"
			@keyup="get_product_by_code(codigo)"
			class="form-control"
			placeholder="Código de Producto"
		  />
		</div>
	  </div>
	  <div class="form-group row">
		<label class="col-sm-2 col-form-label">Producto:</label>
		<div class="col-sm-6">
		  <select
			class="form-control"
			v-model="venta.idproducto"
			@change="getidProducto"
		  >
			<option
			  v-for="obj in lista_productos"
			  :value="obj.idproducto"
			  :key="obj.idproducto"
			  >{{ obj.descripcion }}</option
			>
		  </select>
		</div>
		<div class="col-sm-4">
		  <h3>${{ precio_producto }}</h3>
		</div>
	  </div>
  
	  <div class="form-group row">
		<label class="col-sm-2 col-form-label">Cantidad:</label>
		<div class="col-sm-2">
		  <input
			type="number"
			v-model="venta.cantidad"
			class="form-control"
			placeholder="Cantidad del Producto"
		  />
		</div>
		<label class="col-sm-2 col-form-label">Forma de Pago:</label>
		<div class="col-sm-2">
		  <select
			class="form-control"
			:disabled="permiso == 2"
			v-model="venta.tipoventa"
			@change="gettipoventa"
		  >
			<option
			  v-for="obj in lista_tipoventa"
			  :value="obj.descripcion"
			  :key="obj.descripcion"
			  >{{ obj.descripcion }}</option
			>
		  </select>
		</div>
  
		<!--    <div class="col-sm-1">
	   
		  <input
			type="text"
			v-model="venta.descuento"
			class="form-control"
			placeholder="%"
		  >
		</div>-->
		<button class="btn btn-success" @click="add_product(venta)">+</button>
	  </div>
	  <div class="form-group row">
		<div class="col-md-6">
		  <button class="btn btn-info" @click="guardar_venta">Guardar</button>
		</div>
  
		<div class="col-md-6">
		  <h6>Total de productos:{{ cantidad }}</h6>
		</div>
	  </div>
	  <br />
  
	  <h3>Total: ${{ suma_productos }}</h3>
	  <table class="table table-striped">
		<tr>
		  <th>Cantidad</th>
		  <th>Producto</th>
		  <th>PU</th>
		  <th>PT</th>
		  <th>Forma de Pago</th>
		  <th>&nbsp;</th>
		</tr>
  
		<tbody v-if="lista_venta.length > 0">
		  <tr v-for="(obj, index) in lista_venta" :key="index">
			<td>{{ obj.cantidad }}</td>
			<td>{{ obj.descripcion }}</td>
  
			<td>{{ obj.precio }}</td>
			<td>{{ obj.precio * obj.cantidad }}</td>
			<td>{{ obj.tipoventa }}</td>
			<td>
			  <button @click="delete_product(index)">
				<i class="fa fa-trash"></i>
			  </button>
			</td>
		  </tr>
		</tbody>
	  </table>
  
	  <br />
	</div>
  </template>
  
  <script>
  import { url } from "../main.js";
  import { Datetime } from "vue-datetime";
  import { CoolSelect } from "vue-cool-select";
  import moment from "moment-timezone";
  
  export default {
	components: {
	  datetime: Datetime,
	  CoolSelect,
	},
	computed: {},
	data() {
	  return {
		permiso: 0,
		lista_tipoventa: [
		  {
			descripcion: "Contado",
		  },
		  {
			descripcion: "Crédito",
		  },
		],
  
		codigo: "",
		idproducto: "",
		iduser: 0,
		suma_productos: 0,
		existencia: 0,
		cantidad: 0,
		venta: {
		  idventa: 0,
		  folio: 0,
		  idcliente: 0,
		  idproducto: 0,
		  cantidad: 1,
		  tipoventa: "",
		  fecha: moment()
			.tz("America/Cancun").format()
		},
		cliente: {
		  idcliente: 0,
		  nombre: "",
		  apellido: "",
		  telefono: "",
		  facebook: "",
		  abono_quincenal: 0,
		},
		producto: {
		  idproducto: 0,
		  descripcion: "",
		  existencia: "",
		  marca: "",
		},
  
		descripcion_producto: "",
		precio_producto: "",
		lista_productos: [],
		lista_clientes: [],
		lista_venta: [],
	  };
	},
	mounted() {
	  this.get_clientes();
	  this.get_productos();
	  this.get_folio();
	  this.iduser = localStorage.getItem("iduser");
	  this.permiso = localStorage.getItem("permission");
	},
	methods: {
	  get_product_by_code(codigo) {
		this.lista_productos.forEach((value, index) => {
		  if (value.codigo == codigo) {
			this.venta.idproducto = value.idproducto;
  
			this.descripcion_producto = value.descripcion;
  
			this.precio_producto = value.precio;
			this.existencia = value.existencia;
			this.venta.cantidad = 1;
		  }
		});
	  },
	  get_clientes() {
		this.axios
		  .get(url + "apiVentas.php/get_clientes")
		  .then((respuesta) => {
			console.log(respuesta);
			this.lista_clientes = respuesta.data;
			this.lista_clientes.forEach((element) => {
			  element.nombre_cliente = element.nombre + " " + element.apellido;
			});
			this.idcliente = this.lista_clientes[0].idcliente;
			this.venta.idcliente = this.idcliente;
			console.log(this.lista_clientes);
		  })
		  .catch(function() {
			console.log("FAILURE ver!!");
		  });
	  },
	  get_productos() {
		this.axios
		  .get(url + "apiVentas.php/get_productos")
		  .then((respuesta) => {
			console.log(respuesta);
			this.lista_productos = respuesta.data;
  
			this.idproducto = this.lista_productos[0].idproducto;
			console.log(this.lista_productos);
			this.venta.idproducto = this.idproducto;
			this.descripcion_producto = this.lista_productos[0].descripcion;
  
			this.precio_producto = this.lista_productos[0].precio;
		  })
		  .catch(function() {
			console.log("FAILURE ver!!");
		  });
	  },
	  getidCliente(cliente) {
		console.log(cliente);
		this.cliente = cliente;
		this.lista_venta.forEach((element) => {
		  element.idcliente = cliente.idcliente;
		});
  
		if (this.cliente.nombre != "VENTA") {
		  this.venta.tipoventa = this.lista_tipoventa[1].descripcion;
		}
  
		if (this.cliente.nombre == "VENTA") {
		  this.venta.tipoventa = this.lista_tipoventa[0].descripcion;
		}
  
		/* if (e.target.options.selectedIndex > -1) {
		  this.cliente.idcliente = this.lista_clientes[
			e.target.options.selectedIndex
		  ].idcliente;
		}*/
	  },
	  getidProducto(e) {
		if (e.target.options.selectedIndex > -1) {
		  this.producto.idproducto = this.lista_productos[
			e.target.options.selectedIndex
		  ].idproducto;
		  this.descripcion_producto = this.lista_productos[
			e.target.options.selectedIndex
		  ].descripcion;
  
		  this.precio_producto = this.lista_productos[
			e.target.options.selectedIndex
		  ].precio;
		  this.existencia = this.lista_productos[
			e.target.options.selectedIndex
		  ].existencia;
  
		  this.venta.cantidad = 1;
		}
	  },
	  gettipoventa(e) {
		console.log(this.lista_tipoventa);
		if (e.target.options.selectedIndex > -1) {
		  this.venta.tipoventa = this.lista_tipoventa[
			e.target.options.selectedIndex
		  ].descripcion;
		}
	  },
	  add_product(venta) {
		console.log(this.cliente);
		console.log(this.iduser);
  
		if (this.cliente.idcliente == 0) {
		  this.$swal("Seleccione un cliente");
		} else {
		  if (this.venta.tipoventa == "") {
			this.$swal("Seleccione un método de pago");
		  } else {
			if (this.existencia > 0) {
			  venta.iduser = this.iduser;
			  venta.idcliente = this.cliente.idcliente;
			  venta.descripcion = this.descripcion_producto;
			  venta.precio = this.precio_producto;
			  this.cantidad += parseInt(venta.cantidad);
			  
			  this.suma_productos += parseFloat(venta.precio) * venta.cantidad;
			  console.log(venta.iduser);
			  venta.fecha=moment(venta.fecha).tz("America/Cancun").format("YYYY-MM-DD")
			  console.log(venta.fecha);
			  this.lista_venta.push(Object.assign({}, this.venta));
			  console.log(this.lista_venta);
			} else {
			  this.$swal("No hay existencias para este producto", "", "warning");
			}
		  }
		}
	  },
	  delete_product(index) {
		var v = this.lista_venta[index];
		this.lista_venta.splice(index, 1);
		this.cantidad = this.cantidad - v.cantidad;
		this.suma_productos = this.suma_productos - v.precio * v.cantidad;
	  },
	  guardar_venta() {
		console.log(this.lista_venta);
  
		if (this.lista_venta.length <= 0) {
		  this.$swal("Ingrese productos");
		} else {
		  this.axios
			.post(url + "apiVentas.php/save_venta", this.lista_venta)
			.then((respuesta) => {
			  console.log(respuesta);
			  this.$swal(respuesta.data.msg);
			  if (respuesta.data.status === 200) {
				this.get_folio();
				this.lista_venta = [];
				this.venta.cantidad = 0;
				this.suma_productos = 0;
				this.cantidad = 0;
				this.get_productos();
				this.get_clientes();
			  }
			})
			.catch(function() {
			  console.log("FAILURE!!");
			});
		}
	  },
	  limpiar_campos() {
		this.venta = {};
		this.venta.cantidad = 0;
		this.lista_venta = [];
		this.suma_productos = 0;
		this.venta.fecha=moment().tz("America/Cancun").format();
  
	  },
	  get_folio() {
		this.axios.get(url + "apiVentas.php/get_folio").then((respuesta) => {
		  console.log(respuesta.data);
		  this.venta.folio = respuesta.data;
		});
	  },
	},
  };
  </script>
  


// WEBPACK FOOTER //
// src/views/ventas.vue